import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface NoResultsProps {
  onClearFilters: () => void;
  selectedServiceType?: string;
}

export const NoResults = ({ onClearFilters, selectedServiceType }: NoResultsProps) => {
  return (
    <div className="text-center py-8">
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-100 mb-4">
        <AlertCircle className="w-6 h-6 text-yellow-600" />
      </div>
      <h3 className="text-lg font-semibold mb-2">No contractors found</h3>
      <p className="text-muted-foreground mb-4">
        {selectedServiceType && selectedServiceType !== 'all' 
          ? `No contractors found in the ${selectedServiceType} category.`
          : 'No contractors found with the current filters.'}
      </p>
      <Button onClick={onClearFilters} variant="outline">
        Clear filters
      </Button>
    </div>
  );
};